import { z } from 'zod';

const clock = z.string().regex(/^(?:[01]\d|2[0-3]):[0-5]\d$/u);
export const appointmentTimeWindowSchema = z
  .object({
    startsAt: clock,
    endsAt: clock,
  })
  .strict()
  .refine((value) => value.endsAt > value.startsAt, {
    message:
      'An appointment window must end after it starts on the same local day.',
  });
